import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

const TIPS = [
  { t: "Batch tray of potato", d: "Cook one large tray of potato or sweet potato twice a week. It becomes wedges, mash, hash and lunch salad." },
  { t: "Rice on repeat", d: "Batch cook rice for bowls, stir-fries and burrito bowls. Cool fast and refrigerate." },
  { t: "Cook extra at dinner", d: "Grill extra chicken, beef or fish at dinner for next-day lunch. Zero extra effort." },
  { t: "Boiled eggs ready", d: "Boil 6 at a time. Instant breakfast, snack or salad protein." },
  { t: "Frozen veg on standby", d: "Frozen broccoli, peas and stir-fry mix rescue tired weeknights." },
  { t: "Pantry emergency meals", d: "Tuna rice bowl, eggs on toast, bean chilli — always possible." },
  { t: "Deconstructed family meals", d: "Same ingredients, different assembly. Kids get burritos, you get a bowl." },
];

export default function EatPrep() {
  return (
    <div className="space-y-8" data-testid="eat-prep-page">
      <div>
        <Link to="/app/eat" className="text-xs uppercase tracking-widest text-muted-foreground inline-flex items-center gap-1 hover:text-primary">
          <ChevronLeft size={14} /> Eat
        </Link>
        <div className="label-eyebrow mt-3">Meal Prep</div>
        <h1 className="wordmark mt-2 text-4xl md:text-5xl uppercase leading-[0.95]">Meal Prep Without <span className="text-primary">Living In The Kitchen.</span></h1>
        <p className="mt-2 text-muted-foreground max-w-xl">You don't need Sunday-afternoon meal prep marathons. You need 3–4 small shortcuts that make the whole week easier.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-3">
        {TIPS.map((t, i) => (
          <div key={t.t} className="bg-card border border-border rounded-lg p-5" data-testid={`prep-tip-${i}`}>
            <div className="wordmark text-3xl text-primary">{String(i + 1).padStart(2, "0")}</div>
            <div className="mt-2 font-head uppercase text-lg">{t.t}</div>
            <p className="mt-2 text-sm text-foreground/80 leading-relaxed">{t.d}</p>
          </div>
        ))}
      </div>

      <div className="bg-primary text-primary-foreground rounded-lg p-8">
        <div className="label-eyebrow !text-primary-foreground/80">Rule</div>
        <p className="mt-3 font-head uppercase text-2xl leading-tight">Cook once. Eat twice. Move on.</p>
      </div>
    </div>
  );
}
